module.exports = __webpack_public_path__ + "img/countyClerkImage.b86d55f6.png";